export const API_URL = process.env.API_URL
export const LOGIN_TYPE = process.env.LOGIN_TYPE

export const MAPBOX_URL = process.env.MAPBOX_URL
export const MAPBOX_ENDPOINT = process.env.MAPBOX_ENDPOINT
export const MAPBOX_ACCESS_TOKEN = process.env.MAPBOX_ACCESS_TOKEN

export const ROLLBAR_KEY = process.env.ROLLBAR_KEY
export const ROLLBAR_ENVIRONMENT = process.env.ROLLBAR_ENVIRONMENT